import React, { useState } from "react";
import { Region } from "../../common/layout/region";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import { DocumentFilledIcon } from "../../common/icons";
import GalkButton from "../../common/component/button";
import {
	UploadOutlined,
	DownloadOutlined,
	CloseOutlined,
	LoadingOutlined,
} from "@ant-design/icons";
import { Upload, message, Button, Modal } from "antd";
import {
	uploadCompanyDocument,
	deleteCompanyDocument,
} from "../../../actions/companyActions";
import "./style.css";

const { confirm } = Modal;

const Documents = ({
	userProfile,
	isActionProgress,
	documents,
	uploadCompanyDocument,
	deleteCompanyDocument,
}) => {
	const { isEmpty, isLoaded } = userProfile;
	const { t } = useTranslation();
	const [documentToDelete, setDocumentToDelete] = useState(null);
	const [documentToDeleteId, setDocumentToDeleteId] = useState(null);

	const fetchFileData = async (file) => {
		if (file) {
			// const file = info.file.originFileObj;

			// const isAcceptableFileType =
			// 	file.type === "image/jpeg" ||
			// 	file.type === "image/svg+xml" ||
			// 	file.type === "image/gif" ||
			// 	file.type === "image/png";

			// if (!isAcceptableFileType) {
			// 	message.error("You can only upload jpeg/png/svg/gif file!");
			// }

			const isLt10M = file.size / 1024 / 1024 < 20;

			if (!isLt10M) {
				message.error("file must be smaller than 20MB!");
			}

			if (isLt10M) {
				// const url = await getSrcFromFile(file);
				// setFile(url);
				// setFileObjectList([]);
				console.log("Upload called:", file);
				uploadCompanyDocument(file);
			}
		} else {
			// setFileObjectList([]);
		}

		return false;
	};
	const uploadDocument = (info) => {
		// if (info.file.status !== "uploading") {
		// 	console.log(info.file, info.fileList);
		// }
		// if (info.file.status === "done") {
		// 	message.success(`${info.file.name} file uploaded successfully`);
		// } else if (info.file.status === "error") {
		// 	message.error(`${info.file.name} file upload failed.`);
		// }
	};

	const deleteDocument = (document) => {
		// confirm({
		// 	title: "Are you sure delete this document?",
		// 	icon: <ExclamationCircleOutlined />,
		// 	content: "Once deleted, it can not be recovered",
		// 	okText: t("delete_job_yes"),
		// 	okType: "danger",
		// 	cancelText: t("delete_job_no"),
		// 	onOk() {
		// 		deleteCompanyDocument(document);
		// 		setDocumentToDeleteId(document.id);
		// 	},
		// 	onCancel() {
		// 		// console.log("Cancel");
		// 	},
		// });
		setDocumentToDelete(document);
	};
	const deleteOk = () => {
		deleteCompanyDocument(documentToDelete);
		setDocumentToDelete(null);
	};

	return (
		<Region>
			{isLoaded && !isEmpty && (
				<>
					<div className="accountSetting_pageTitle">
						{t("documents_page_title")}
					</div>
					<div className="documentPage_action_container">
						<Upload
							name="file"
							onChange={uploadDocument}
							beforeUpload={fetchFileData}
							maxCount={1}
							showUploadList={false}
							// listType="picture"
							// fileList={fileObjectList}
							disabled={isActionProgress}
						>
							<GalkButton
								type="primary"
								onClick={() => {}}
								disabled={isActionProgress}
								additionalStyle={{ padding: "13px 16px" }}
							>
								{isActionProgress ? <LoadingOutlined /> : <UploadOutlined />}
								{t("documents_action_upload")}
							</GalkButton>
						</Upload>
					</div>
					<div className="documentPage_body_container">
						<div className="table_area">
							<table>
								<thead>
									<tr>
										<th>{t("document_name")}</th>
										<th>{t("document_date")}</th>
										<th>{t("document_size")}</th>
										<th colSpan={2}>{t("action")}</th>
									</tr>
								</thead>
								<tbody>
									{[...documents].map((document, index) => (
										<tr key={index}>
											<td>
												<div className="documentTitle">
													<DocumentFilledIcon />
													{document.name}
												</div>
											</td>
											<td>{document.updateDate}</td>
											<td>{parseFloat(document.size).toFixed(2)} MB</td>
											<td>
												<a
													className="downLoadButton"
													href={document.link}
													target="_blank"
												>
													<DownloadOutlined />
													{t("download")}
												</a>
											</td>
											<td>
												{document.downloadEnabled && (
													<div
														className="downLoadRemoveButton"
														onClick={
															isActionProgress
																? () => {}
																: () => deleteDocument(document)
														}
													>
														{isActionProgress &&
														documentToDelete &&
														documentToDelete.id === document.id ? (
															<LoadingOutlined />
														) : (
															<CloseOutlined />
														)}
													</div>
												)}
											</td>
										</tr>
									))}
								</tbody>
							</table>
						</div>
					</div>
					{documentToDelete && (
						<Modal
							title={`${t("documents_action_delete_confirm_title")}`}
							visible={true}
							onCancel={() => setDocumentToDelete(null)}
							footer={null}
						>
							<div className="teamMember_deleteMember_modalBody_container">
								<div className="teamMember_deleteMember_modalBody">
									<div className="details">
										<div className="name">{documentToDelete.name}</div>
										<div className="email">
											Last updated: {documentToDelete.updateDate}
										</div>
									</div>
								</div>
								<div className="project-form-controls-cont">
									<GalkButton
										type="primary"
										additionalStyle={{ padding: "13px 16px" }}
										onClick={deleteOk}
									>
										{t("accountSetting_deleteModal_actionButton_delete")}
									</GalkButton>
								</div>
							</div>
						</Modal>
					)}
				</>
			)}
		</Region>
	);
};

const mapStateToProps = (state) => ({
	userProfile: state.firebase.profile,
	documents: state.company.company.documents || [],
	isActionProgress: state.company.actionInProgress,
});

export default connect(mapStateToProps, {
	uploadCompanyDocument,
	deleteCompanyDocument,
})(Documents);
